module.exports = __webpack_public_path__ + "static/media/List_of_Amenities.cce4ade4.png";